import { apiErrorMessage } from "../helpers/apiErrorMessage";
import { createModule } from "saga-slice";
import { call, put } from "redux-saga/effects";
import stockService from "../services/stockService";
import supplierProductService from "../services/supplierProductService";
const initialState = {
    suppliersProducts: [],
    loading: false,
    error: null,
    totalElements: 0, // Total number of records
    totalPages: 0, // Total number of pages
    pageNumber: 0, // Current page number
    pageSize: 10, // Size of each page
};

const supplierProductSlice = createModule({
    name: 'suppliersProducts',
    initialState,
    reducers: {
        addSupplier: (state) => {
            state.loading = true;
        },
        search: (state) => {
            state.loading = true;
        },
        updateSupplier: (state) => {
            state.loading = true;
        },
        deleteSupplier: (state, action) => {
            state.loading = true;
        },
        generatePdfReleve: (state) => {
            state.loading = true;
        },
        generatePdfSuccess: (state) => {
            state.loading = false;
        },
        generatePdfFailure: (state, action) => {
            state.loading = false;
            state.error = apiErrorMessage(action);
        },
       
        fetchedData: (state, payload) => {
            state.loading = false;
            state.suppliersProducts = payload.body.content;
            state.totalElements = payload.body.totalElements; // Assuming totalElements is in payload
            state.totalPages = payload.body.totalPages; // Assuming totalPages is in payload
            state.pageNumber = payload.body.pageNumber;
        },
        finishFetching: (state) => {
            state.isFetching = false;
        },
        fetchError: (state, action) => {
            state.isFetching = false;
            state.error = apiErrorMessage(action);
        },
    },
    sagas: (A) => ({
        *[A.search]({ payload }) {
            try {
                console.log(payload);
                const { data } = yield call(supplierProductService.search, payload);
                yield put(A.finishFetching());
                yield put(A.fetchedData(data));
            } catch (e) {
                console.log(e);
                yield put(A.finishFetching());
                yield put(A.fetchError());
            }
        },
        *[A.addSupplier]({ payload }) {
            try {
                const { data } = yield call(supplierProductService.save, payload);
                yield put(A.finishFetching());
                yield call(payload.onSuccess);
            } catch (e) {
                console.log(e);
                yield put(A.finishFetching());
                yield put(A.fetchError());
            }
        },

        *[A.updateSupplier]({ payload }) {
            try {
                const { data } = yield call(supplierProductService.update, payload);
                yield put(A.finishFetching());
                yield call(payload.onSuccess);

            } catch (e) {
                console.log(e);
                yield put(A.finishFetching());
                yield put(A.fetchError());
            }
        },
        *[A.deleteSupplier]({ payload }) {
            try {
                const { data } = yield call(supplierProductService.delete, payload.id);
                yield put(A.finishFetching());
                yield call(payload.onSuccess);
            } catch (e) {
                console.log(e);
                yield put(A.finishFetching());
                yield put(A.fetchError());
            }
        },
        
        
    }),
});

export default supplierProductSlice;
export const supplierProductActions = supplierProductSlice.actions;
export const supplierProductsSelectors = {
    getSuppliersProduct: state => state.suppliersProducts || [],
    getSuppliersLoading: state => state.loading || false,
    getSuppliersTotalPages: state => state.totalPages || 0,
    getSuppliersTotalElements: state => state.totalElements || 0
  };